import { Dtos, SuretyAccountId, SuretyAccountUnderwritingId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountLatestUnderwritingQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUpdateUnderwritingExpiration = (
	accountId: SuretyAccountId,
	underwritingId: SuretyAccountUnderwritingId,
) => {
	const { patch } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.Admin.SuretyAccount.Update.UnderwritingExpiration.Request) => {
			await patch(
				`/v2/admin/surety/accounts/${accountId}/underwritings/${underwritingId}/expiration`,
				data,
				"none",
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({
				queryKey: accountLatestUnderwritingQueryKey(accountId),
			});
		},
	});

	return {
		updateUnderwritingExpiration: mutation.mutate,
		updateUnderwritingExpirationIsLoading: mutation.isPending,
		updateUnderwritingExpirationError: mutation.error,
		updateUnderwritingExpirationSuccess: mutation.isSuccess,
	};
};
